import Image from 'next/image';
import type { SubsectionCardConfig } from '../../state/cardSchema';
import { CardRenderer } from '../../CardRenderer';
import { Section } from '../Section';
import styles from './SubsectionCard.module.css';

export type SubsectionCardProps = {
  card: SubsectionCardConfig;
};

export const SubsectionCard = ({ card }: SubsectionCardProps) => {
  return (
    <Section id={card.id} title={card.title} subtitle={card.subtitle} info={card.info}>
      {card.image ? (
        <div className={styles.headerImage}>
          <Image
            src={card.image}
            alt=""
            width={400}
            height={225}
            aria-hidden="true"
          />
        </div>
      ) : null}
      <CardRenderer card={card.child} />
    </Section>
  );
};
